import { useLayoutEffect, useState } from 'react';
import { myEvent } from '@crm/eventemitter';
declare const i18next: any;

export const useTranslation = () => {
  const [_, setIndex] = useState(0);

  useLayoutEffect(() => {
    myEvent.subscribe({
      next: ({ event }) => {
        if (event !== 'TRIGGER_LANGUAGE_CHANGE') return;
        setIndex(Date.now());
      },
    });
  }, []);

  return i18next;
};
